/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ size: NonNullable<unknown> }} Settings_Photo_DescInputs */



/**
* | output |
* | --- |
* | "JPG, PNG or WebP, up to {size}." |
*
* @param {Settings_Photo_DescInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_photo_desc = /** @type {((inputs: Settings_Photo_DescInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Photo_DescInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`JPG, PNG of WebP, maximaal ${i?.size}.`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`JPG, PNG ou WebP, ${i?.size} maximum.`)
	return /** @type {LocalizedString} */ (`JPG, PNG or WebP, up to ${i?.size}.`)
});